const ticketTypes = {
	LIST: {
		REQUEST: 'TICKET_LIST_REQUEST',
		SUCCESS: 'TICKET_LIST_SUCCESS',
		FAILURE: 'TICKET_LIST_FAILURE',
		CLEAR: 'TICKET_LIST_CLEAR',
	},

	INDEX: {
		REQUEST: 'TICKET_INDEX_REQUEST',
		SUCCESS: 'TICKET_INDEX_SUCCESS',
		FAILURE: 'TICKET_INDEX_FAILURE',
	},

	CREATE: {
		REQUEST: 'TICKET_CREATE_REQUEST',
		SUCCESS: 'TICKET_CREATE_SUCCESS',
		FAILURE: 'TICKET_CREATE_FAILURE',
	},

	COMMENT: {
		REQUEST: 'TICKET_COMMENT_REQUEST',
		SUCCESS: 'TICKET_COMMENT_SUCCESS',
		FAILURE: 'TICKET_COMMENT_FAILURE',
		CLEAR: 'TICKET_COMMENT_CLEAR',
	},

	LOG: {
		REQUEST: 'TICKET_LOG_REQUEST',
		SUCCESS: 'TICKET_LOG_SUCCESS',
		FAILURE: 'TICKET_LOG_FAILURE',
		CLEAR: 'TICKET_LOG_CLEAR',
	},
	SUPPORT_PROBLEM: {
		REQUEST: 'SUPPORT_PROBLEM_REQUEST',
		SUCCESS: 'SUPPORT_PROBLEM_SUCCESS',
		FAILURE: 'SUPPORT_PROBLEM_FAILURE',
		CLEAR: 'SUPPORT_PROBLEM_CLEAR',
	},
};

export default ticketTypes;
